import { toast } from 'react-toastify';
import { store } from '../../store';
import axios, { setAuthorizationHeaders } from '../config/index'; // axios instance kamu

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
        if (error) prom.reject(error);
        else prom.resolve(token);
    });
    failedQueue = [];
};

const errorHandler = async (error) => {
    const originalRequest = error.config;

    // 🔐 TOKEN EXPIRED
    if (error.response.status === 401 && error.response.data?.error?.code === 'TOKEN_EXPIRED') {
        // ⛔ Prevent infinite loop
        if (originalRequest._retry) {
            return Promise.reject(error);
        }

        originalRequest._retry = true;

        const state = store.getState();
        const refreshTokenValue = state.reduxState?.refreshToken;

        if (!refreshTokenValue) {
            toast.error('Session expired, please login again');
            return Promise.reject(error);
        }

        if (isRefreshing) {
            return new Promise((resolve, reject) => {
                failedQueue.push({ resolve, reject });
            })
                .then((newAccessToken) => {
                    originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                    return axios(originalRequest);
                })
                .catch((err) => Promise.reject(err));
        }
        console.log('Refreshing token...');

        isRefreshing = true;
        try {
            // 🔄 REFRESH TOKEN
            const res = await axios.post('/auth/refresh-token', { refreshToken: refreshTokenValue }, { withCredentials: true });

            const newAccessToken = res.data?.accessToken;
            const newRefreshToken = res.data?.refreshToken;

            store.dispatch({ type: 'set', accessToken: newAccessToken, refreshToken: newRefreshToken });

            setAuthorizationHeaders(newAccessToken);

            if (!newAccessToken) throw new Error('Refresh token failed');

            // 🔑 Set token baru
            axios.defaults.headers.Authorization = `Bearer ${newAccessToken}`;
            originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

            processQueue(null, newAccessToken);

            return axios(originalRequest); // 🔁 RETRY REQUEST
        } catch (err) {
            console.log(err, '<=== refresh token error');
            processQueue(err, null);
            store.dispatch({ type: 'set', accessToken: false, refreshToken: false });
            setAuthorizationHeaders(null);
            window.location.href = '/login';
            // toast.error('Session expired, please login again');
            return Promise.reject(err);
        } finally {
            isRefreshing = false;
        }
    }

    if (!error.response) {
        toast.error('Network error');
        return Promise.reject(error);
    }

    // ❌ Error lain
    const message = error.response?.data?.error?.message || error.response?.data?.error?.details || 'Something went wrong';

    if (!originalRequest.url.includes('/auth/refresh')) {
        toast.error(message);
    }

    return Promise.reject(error);
};

export default errorHandler;
